import h from 'virtual-dom/h'
import { processResponse, 
         getFirstResponseActionNamed,
       } from '@nextit/nextit-lib-response-handler';

export default class nextitInlineSurveyLinks {
    constructor(settings, singleLinkRenderer) {
        this._settings = settings;
        this._singleLinkRenderer = singleLinkRenderer;
    }

    initialize(store) {
        this._store = store;
    }

    getReducer() { return state => state }

    getRenderer() { 
        return () => {
            let addBreakpointHereToDebugSurvey = null;
        } 
    }

    process(message) {
        const options = {
            processSingle: this.processResponse.bind(this),
        };
        return processResponse(message, options);
    }

    processResponse(response){
        if (!response || !response.responseActions)
            return response;
            
        let { 
                disableSurveyResponseActionName,
                entryIdResponseActionName, 
                inlineSurveyResponseActionName,
            } = this._settings.responseActionConstants;

        let entryIdAction = getFirstResponseActionNamed(response, entryIdResponseActionName);
        // We need that entry ID or there's not much we can do. 
        // Bail if it's not there.
        if (!entryIdAction || !entryIdAction.Value) {
            console && console.log(`Entry ID response action or value missing!`)
            return response;
        }

        let surveyAction = getFirstResponseActionNamed(response, inlineSurveyResponseActionName);
        let disableLinksAction = getFirstResponseActionNamed(response, disableSurveyResponseActionName);

        let entryId = entryIdAction.Value;

        if (!!surveyAction) {
            this.addSurveyToResponse(response, entryId, surveyAction.SurveyUnitLabel);
        }

        if (!!disableLinksAction) {
            this.disableSurveyLinks(disableLinksAction.entryId);
        }

        return response;
    }

    addSurveyToResponse(response, entryId, SurveyUnitLabel) {
        let survey = this.renderSurvey(entryId, SurveyUnitLabel);
        if (!response.html) {
            response.html = [];
        }
        response.html.push(survey);
    }

    renderSurvey(entryId, SurveyUnitLabel) {
        let attr = { 
            className: this._settings.classNames.inlineSurveyLinks, 
            id: this.getSurveyId(entryId)
        };
        let children = [
            h('span', {}, this._settings.textConstants.inlineSurveyTitle),
            this.getYesLink(entryId, SurveyUnitLabel),
            this.getNoLink(entryId, SurveyUnitLabel)
        ];

        let survey = h('div', attr, children);
        return survey;
    }

    getYesLink(entryId, SurveyUnitLabel) {
        let spec = Object.assign({ parameters: {} }, 
                    this._settings.InlineSurveyLinks.Yes);

        spec.parameters.entryId = entryId;
        spec.parameters.SurveyUnitLabel = SurveyUnitLabel;
        if (this._settings.classNames.inlineSurveyYesLink) {
            spec.className = this._settings.classNames.inlineSurveyYesLink;
        }

        let yesLink = this._singleLinkRenderer.renderLink(spec);
        return yesLink;
    }

    getNoLink(EntryId, SurveyUnitLabel) {
        let Handler = ((e) =>  
            this._store.dispatch({ type: 'SHOW_SURVEY', EntryId, SurveyUnitLabel})).bind(this);
        let spec = { href: '#', onclick: Handler };
        if (this._settings.classNames.inlineSurveyNoLink) {
            spec.className = this._settings.classNames.inlineSurveyNoLink;
        }

        let noLink = h('a', spec, 
                       this._settings.InlineSurveyLinks.No.DisplayText) 
        return noLink;
    }

    getSurveyId(EntryId) {
        return 'nit-survey-' + EntryId;
    }

    disableSurveyLinks(EntryId) {
        if (!EntryId)
            return;

        //IE doesn't support nodelist
        if (!NodeList.prototype.forEach)
            NodeList.prototype.forEach = Array.prototype.forEach

        let id = this.getSurveyId(EntryId), attempts = 0;

        // Keep trying to disable it until it exists
        (function disable() {
            let survey = document.getElementById(id);
            if (survey) {
                survey.childNodes.forEach(c => {
                    c.onclick = null;
                    c.className = "survey-link-disabled";
                    c.setAttribute("tabindex","-1");
                })
                return;
            }

            console && console.log(`No survey found with id ${EntryId}!`);
            attempts++;
            if (attempts < 20) {
                setTimeout(disable, 100)
            }
        }());
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nextit/nextit-response-handler-inline-survey-links/src/nextit-inline-survey-links.js